import {
  ADD_MESSAGE,
  UPDATE_MESSAGE,
  DELETE_MESSAGE,
  CLEAR_MESSAGES,
  SET_MESSAGES,
  UPDATE_STREAM_DATA,
  CLEAR_STREAM_DATA,
  SET_LOADING
} from './types'

// Add a new message
export const addMessage = (message) => ({
  type: ADD_MESSAGE,
  payload: {
    id: message.id || Date.now().toString(),
    sessionId: message.sessionId,
    role: message.role, // 'user' or 'assistant'
    content: message.content,
    timestamp: message.timestamp || new Date().toISOString(),
    status: message.status || 'sent', // 'sending', 'sent', 'error'
    metadata: message.metadata || {},
    isStreaming: message.isStreaming || false,
    completedAt: message.completedAt,
    citations: message.citations || []
  }
})

// Update an existing message
export const updateMessage = (messageId, updates) => ({
  type: UPDATE_MESSAGE,
  payload: { messageId, updates }
})

// Delete a message
export const deleteMessage = (messageId) => ({
  type: DELETE_MESSAGE,
  payload: messageId
})

// Clear all messages for a session
export const clearMessages = (sessionId = null) => ({
  type: CLEAR_MESSAGES,
  payload: sessionId
})

// Set messages (for loading from storage/API)
export const setMessages = (messages) => ({
  type: SET_MESSAGES,
  payload: messages
})

// Update stream data during research
export const updateStreamData = (phase, data) => {
  console.log('🔄 updateStreamData called:', {
    phase,
    data,
    dataKeys: data ? Object.keys(data) : []
  })
  
  return {
    type: UPDATE_STREAM_DATA,
    payload: { phase, data }
  }
}

// Clear stream data
export const clearStreamData = () => ({
  type: CLEAR_STREAM_DATA
})

// Set loading state
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading
})

// Add user message and prepare for response
export const sendMessage = (content, sessionId) => (dispatch) => {
  console.log('📤 Sending message for session:', sessionId, 'content:', content.substring(0, 50) + '...')
  
  // Add user message
  const userMessageId = Date.now().toString()
  const userMessage = {
    id: userMessageId,
    sessionId,
    role: 'user',
    content,
    status: 'sent'
  }
  console.log('👤 Adding user message:', userMessageId, 'to session:', sessionId)
  dispatch(addMessage(userMessage))
  
  // Set loading state
  dispatch(setLoading(true))
  
  // Clear previous stream data
  dispatch(clearStreamData())
  
  // Add placeholder assistant message
  const assistantMessageId = (Date.now() + 1).toString()
  const assistantMessage = {
    id: assistantMessageId,
    sessionId,
    role: 'assistant',
    content: '',
    status: 'receiving',
    isStreaming: true
  }
  console.log('🤖 Adding assistant placeholder message:', assistantMessageId, 'to session:', sessionId)
  dispatch(addMessage(assistantMessage))
  
  return { userMessageId, assistantMessageId }
}

// Update assistant message with final answer
export const finalizeAssistantMessage = (messageId, answer, citations) => (dispatch, getState) => {
  console.log('🏁 Finalizing assistant message:', messageId, 'with answer length:', answer?.length)
  console.log('📝 Answer preview:', answer?.substring(0, 100) + '...')
  
  // Capture current stream data to preserve it
  const { streamData } = getState().messages
  console.log('📊 Preserving stream data:', streamData)
  
  dispatch(updateMessage(messageId, {
    content: answer,
    citations,
    status: 'received',
    isStreaming: false,
    completedAt: new Date().toISOString(),
    metadata: {
      researchSummary: streamData // Preserve all the research data
    }
  }))
  
  dispatch(setLoading(false))
}